<script>
  import { _, locale } from "svelte-i18n";
  import { init, getLocaleFromNavigator } from "svelte-i18n";
  import { Route, router, meta } from "tinro";
  import { BASE_URL } from "../utilities/config.js";
  import { createEventDispatcher, onMount } from "svelte";
  import { postJsonFileNoResponse, api } from "../utilities/Utils.svelte";
  import {
    currentPage,
    skillId,
    cid,
    userId,
    userName,
    assessmentType,
    assessmentId,
    instanceId,
    assessmentState,
    assessmentDefinitionId,
    termsAndConditionOpen,
    privacyPolicyOpen,
    portraitPolicyOpen,
    activationCode,
    invitationNumber,
    readinessCheckCompleted,
  } from "../utilities/DataStore.js";
  import TermsAndConditions from "./components/TermsAndConditions.svelte";
  import PrivacyPolicy from "./components/PrivacyPolicy.svelte";
  import LiteonImagePolicy from "./components/LiteonImagePolicy.svelte";

  export let activationCodeDefault;

  let errorMsg = undefined;
  let loadingState = "NEW";

  let radioAssessmentType = "ENGDEMO";
  let email;
  let name;
  let activationCodeValue = "LITEON";
  let invitationNumberValue;
  let locationProgram;
  let jobFunction;
  let idNumber;
  let photoPolicyChecked;

  let isValidEmail;
  let isValidName;
  let isValidActivationCode;
  let isValidLocationProgram;
  let isValidIdNumber;
  let isValidJobFunction;
  let isValidPortraitPolicyChecked;
  let submitTry = false;

  let language;

  onMount(async () => {
    language = getLocaleFromNavigator();
    if (!["en-US", "zh-TW"].includes(language)) {
      language = "en-US";
    }

    const url_string = window.location.href;
    const url = new URL(url_string);
    activationCodeValue = url.searchParams.get("activationCode");
    url.searchParams.delete("activationCode");
    console.log("activationCode", activationCodeValue);

    invitationNumberValue = url.searchParams.get("invitationNumber");
    let iValue = url.searchParams.get("i");
    if (!invitationNumberValue && iValue) {
      invitationNumberValue = iValue;
    }
    console.log("invitationNumber", invitationNumberValue);

    if (invitationNumberValue) {
      loadInvitationData();
    }

    console.log(222, activationCodeValue, activationCodeDefault);

    init({
      fallbackLocale: "en",
      initialLocale: language,
    });
  });

  async function loadInvitationData() {
    return fetch(
      BASE_URL + `/public/assessment/invitation/${invitationNumberValue}`,
    )
      .then((response) => {
        if (!response.ok) {
          console.log("response error");

          throw new Error("Network response was not ok");
        }
        console.log("response ok", response);
        return response.json();
      })
      .then((data) => {
        let invitationData = data;
      })
      .catch((error) => {
        console.log("catch error", error);
      });
  }

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  function validateEmail(value) {
    var input = document.createElement("input");

    input.type = "email";
    input.required = true;
    input.value = value;

    return input.checkValidity();
  }

  function startAssessment() {
    submitTry = true;

    if (email) {
      isValidEmail = validateEmail(email);
    } else {
      isValidEmail = false;
    }

    if (name) {
      isValidName = true;
    } else {
      isValidName = false;
    }

    if (locationProgram) {
      isValidLocationProgram = true;
    } else {
      isValidLocationProgram = false;
    }

    if (jobFunction) {
      isValidJobFunction = true;
    } else {
      isValidJobFunction = false;
    }

    if (idNumber && idNumber.length >= 8 && idNumber.length <= 10) {
      isValidIdNumber = true;
    } else {
      isValidIdNumber = false;
    }

    if (photoPolicyChecked) {
      isValidPortraitPolicyChecked = true;
    } else {
      isValidPortraitPolicyChecked = false;
    }

    activationCodeValue = "LITEON";

    if (
      activationCodeValue === "104" ||
      activationCodeValue === "PARO" ||
      activationCodeValue === "STUDY2021" ||
      activationCodeValue === "CLN2021" ||
      activationCodeValue === "TRIAL2021" ||
      activationCodeValue === "NTNU" ||
      activationCodeValue === "DEMO" ||
      activationCodeValue === "LITEON" ||
      activationCodeValue === "ELPAC"
    ) {
      isValidActivationCode = true;
    } else {
      isValidActivationCode = false;
    }

    // isValidActivationCode = true;

    if (
      isValidEmail &&
      isValidName &&
      isValidActivationCode &&
      isValidLocationProgram &&
      isValidJobFunction &&
      isValidIdNumber &&
      isValidPortraitPolicyChecked
    ) {
      // Liteon requirement: landing page is localized, assessment flow stays EN.
      language = "en-US";
      locale.set("en-US");

      $assessmentId = makeid(7);
      // $assessmentType = radioAssessmentType;
      $userId = email;
      $userName = name;
      $activationCode = activationCodeValue;

      loadingState = "LOADING";

      checkOrCreateInvitation().then(async () => {
        $assessmentState = "START";
        $readinessCheckCompleted = false;
        if ($invitationNumber) {
          try {
            const DONE_STATUSES = ["SCORED", "DONE", "SUBMITTED", "ENDED", "CANCEL", "EXPIRED"];
            const defs = await api.get(`public/assessment/invitation/${$invitationNumber}/definitions-detail`).json();
            const allDone = defs.length > 0 && defs.every(d => DONE_STATUSES.includes(d.invDefStatus) || DONE_STATUSES.includes(d.status));
            if (allDone) {
              $currentPage = "AssessmentSelection";
              return;
            }
          } catch (e) {
            // fall through to IntroductionPage
          }
        }
        $currentPage = "IntroductionPage";
      });

      // uploadUserInit().then(() => {
      //   $assessmentState = "START";
      //   $currentPage = "AssessmentSelection";
      // });
    } else {
      console.log("Validation failed");
    }
  }

  function onChangeType(event) {
    radioAssessmentType = event.currentTarget.value;
  }

  async function uploadUserInit() {
    const uploadUserInit = {
      name: name,
      email: email,
      assessmentId: $assessmentId,
      assessmentType: "INIT",
      activationCode: $activationCode,
      uiLanguage: language,
      locationProgram: locationProgram,
      jobFunction: jobFunction,
      idNumber: idNumber,
    };

    await postJsonFileNoResponse(
      BASE_URL + "/public/assessment/meetTaipei",
      { "Content-Type": "application/json" },
      {},
      uploadUserInit,
    )
      .then((data) => {
        console.log("send data to sensay", data);
        // mixpanel.track("MeetTaipeiTracking", uploadUserInit);
      })
      .catch((error) => {
        console.error("error sending data to sensay", error);
      });
  }

  let invitationData;
  async function checkOrCreateInvitation() {
    if (invitationNumberValue) {
      await fetch(
        BASE_URL +
          `/public/assessment/invitation2/${invitationNumberValue}?clientId=${email}`,
      )
        .then((response) => {
          if (!response.ok) {
            console.log("response error");

            throw new Error("Network response was not ok");
          }
          console.log("response ok", response);
          return response.json();
        })
        .then((data) => {
          invitationData = data;

          $invitationNumber = data?.invitationNumber;

          // const url = new URL(window.location.href);
          // url.searchParams.set("invitationNumber", $invitationNumber);
          router.goto("/invitation/" + $invitationNumber);
          // window.history.replaceState({}, "", url);
        })
        .catch(async (error) => {
          console.log("catch error", error);
        });
    } else {
      // Only attempt to fetch existing invitation if email is valid
      if (email && email.trim()) {
        try {
          const response = await api.get(`public/assessment/invitation2`, {
            searchParams: { clientId: email },
          });

          invitationData = await response.json();
          $invitationNumber = invitationData?.invitationNumber;

          router.goto("/invitation/" + $invitationNumber);
        } catch (error) {
          console.log("catch error - no existing invitation found", error);
        }
      }

      //Create New One if didn't find previous one
      if (!$invitationNumber) {
        const payload = {
          clientName: name,
          clientId: email,
          assessmentType: "TOEIC",
          invitationNumber: makeid(8),
          activationCode: $activationCode,
          status: "NEW",
          data: JSON.stringify({
            locationProgram: locationProgram,
            jobFunction: jobFunction,
            idNumber: idNumber,
          }),
        };

        await fetch(
          BASE_URL + `/public/assessment/invitation?activationCode=LITEON`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          },
        )
          .then((response) => {
            if (!response.ok) {
              console.log("response error");

              throw new Error("Network response was not ok");
            }
            console.log("response ok", response);
            return response.json();
          })
          .then((data) => {
            invitationData = data;

            $invitationNumber = invitationData?.invitationNumber;
            router.goto("/invitation/" + $invitationNumber);
          })
          .catch((error) => {
            console.log("catch error", error);
          });
      }
    }
  }

  function changeLanguage(value) {
    language = value;
    console.log("changeLanguage", language);
    if (language && (language === "en-US" || language === "zh-TW")) {
      init({
        fallbackLocale: "en",
        initialLocale: language,
      });
    } else {
      init({
        fallbackLocale: "en",
        initialLocale: getLocaleFromNavigator(),
      });
    }
  }
</script>

<TermsAndConditions />
<PrivacyPolicy />
<LiteonImagePolicy />
<div class="container">
  <div class="px-4 py-1 my-5 text-center">
    <div class="container col-xl-12 col-xxl-10 px-4 py-1">
      <div class="row align-items-start g-lg-5 py-1">
        <div
          class="col-lg-7 text-left align-items-start text-lg-start mb-3 mt-4"
        >
          <!-- <img
            class="d-block mx-auto mb-4"
            src="assets/img/logo_2_report.png"
            alt=""
            width="200px"
          /> -->

          <div class="mt-4 mb-2">
            <span class="yellow-banner">Sensay x LiteOn</span>
          </div>

          <h3 class="display-6 fw-bold lh-1 mb-3">
            {$_("ENGLISH_ASSESSMENT")}
          </h3>

          <h4>{$_("LANDING_LITEON_INSTRUCTION")}</h4>
          <ul>
            <li>{$_("LANDING_LITEON_EQUIPMENT_PART1")}</li>
            <li class="webcam-test-link">{@html $_("LANDING_LITEON_EQUIPMENT_PART2")}</li>
          </ul>
          <h4 class="section-title">{$_("LANDING_LITEON_EQUIPMENT")}</h4>
          <ul>
            <li>{$_("LANDING_LITEON_ASSESSMNET_PROTOCOL_PART1")}</li>
            <li>{$_("LANDING_LITEON_ASSESSMNET_PROTOCOL_PART2")}</li>
            <li>{$_("LANDING_LITEON_ASSESSMNET_PROTOCOL_PART3")}</li>
          </ul>
          <h4 class="section-title">{$_("LANDING_LITEON_ASSESSMNET_PROTOCOL")}</h4>


          <p>{$_("LANDING_LITEON_ASSESSMNET_NOTE")}</p>
          <!-- <h3 class="display-6 fw-bold lh-1 mb-3">
            {$_("ENGLISH_SPEAKING_ASSESSMENT_EXPLANATION")}
          </h3> -->
          <!-- <h5 class="display-8 fw-bold lh-1 mb-3">{$_("WE_OFFER_TWO_TESTS")}</h5> -->
          <!-- <div class="text-center mb-3">
            {$_("ENG1_AND_ENG2_ARE_FREE_EXPLANATION")}
          </div> -->
          <!-- <p class="text-left mb-3">
            {$_("ENGLISH_SPEAKING_ASSESSMENT_EXPLANATION.WHITELABEL")}
          </p> -->
          <!-- <div class="text-center mb-3">
            {$_("ITS_GREAT_PRACTICE")}
          </div> -->
          <!-- <div class="text-center">
            {$_("FREE_REPORT_WITH_APROXIMATES")}
          </div> -->

          <div class="mb-4" style="margin-top: 1em;">
            <span
              ><a
                href="https://www.oksensay.com/assessment-project-with-ntnu-rcemi/"
                ><img
                  style="margin-right: 1em;"
                  src="assets/img/logo_horizontal_nobg2.png"
                /></a
              ></span
            >
            <span
              ><img
                style="width: 240px; height: auto;"
                src="assets/img/logo_liteon2.png"
              /></span
            >
          </div>
        </div>
        <div class="col-md-10 mx-auto col-lg-5">
          <form
            class="p-4 p-md-5 border rounded-3 bg-light"
            on:submit|preventDefault={startAssessment}
          >
            <div class="form-floating mb-3">
              <label for="emailInput">{$_("EMAIL_ADDRESS")}</label><input
                type="email"
                bind:value={email}
                class="form-control"
                id="emailInput"
                placeholder="name@example.com"
                class:is-valid={submitTry && isValidEmail}
                class:is-invalid={submitTry && !isValidEmail}
              />
              <div class="valid-feedback" />
              <div class="invalid-feedback">
                {$_("EMAIL_ADDRESS_VALIDATION")}
              </div>
            </div>

            <div class="form-floating mb-3">
              <label for="nameInput">{$_("NAME")}</label><input
                type="text"
                bind:value={name}
                class="form-control"
                id="nameInput"
                placeholder="name"
                class:is-valid={submitTry && isValidName}
                class:is-invalid={submitTry && !isValidName}
              />
              <div class="valid-feedback" />
              <div class="invalid-feedback">{$_("NAME_VALIDATION")}</div>
            </div>

            <div class="form-floating mb-3">
              <label for="nameInput">{$_("LOCATION_PRORGAM")}</label>

              <select
                class="form-control"
                bind:value={locationProgram}
                class:is-valid={submitTry && isValidLocationProgram}
                class:is-invalid={submitTry && !isValidLocationProgram}
              >
                <option value=""></option>
                <option value="LIGHT SEEKER">LIGHT SEEKER</option>
                <option value="LiMI">LiMI</option>
                <option value="Pilot.Z.GlobalPower">Pilot Z Global Power</option>
                <option value="Pilot.Z.Cross">Pilot Z Cross</option>
                <option value="RD.Substitute">RD Substitute</option>
                <option value="Taiwan">Taiwan</option>
                <option value="Vietnam">Vietnam</option>
                <option value="PRC GZ IVS">PRC GZ IVS</option>
                <option value="PRC GZ IMG">PRC GZ IMG</option>
                <option value="PRC GZ AVS">PRC GZ AVS</option>
                <option value="PRC CA Power">PRC CA Power</option>
                <option value="PRC GZ Enclosure">PRC GZ Enclosure</option>
                <option value="PRC BJ VS SBU">PRC BJ VS SBU</option>
                <option value="PRC QX SS SBU">PRC QX SS SBU</option>
                <option value="PRC CZ HIS SBU">PRC CZ HIS SBU</option>
                <option value="PRC OCS">PRC OCS</option>
                <option value="AEA Guang Zhou">AEA Guang Zhou</option>
                <option value="AE 2026">AE 2026</option>
              </select>

              <div class="valid-feedback" />
              <div class="invalid-feedback">
                {$_("LOCATION_PRORGAM_VALIDATION")}
              </div>
            </div>

            <div class="form-floating mb-3">
              <label for="nameInput">{$_("JOB_FUNCTION")}</label>
              <select
                class="form-control"
                bind:value={jobFunction}
                class:is-valid={submitTry && isValidJobFunction}
                class:is-invalid={submitTry && !isValidJobFunction}
              >
                <option value=""></option>
                <option value="INTERN">INTERN</option>
                <option value="RD">RD</option>
                <option value="Sale">Sale</option>
                <option value="MKT">MKT</option>
                <option value="CS">CS</option>
                <option value="ENG">ENG</option>
                <option value="MFG">MFG</option>
                <option value="LAW">LAW</option>
                <option value="IT">IT</option>
                <option value="GA/OA">GA/OA</option>
                <option value="HR">HR</option>
                <option value="FIN">FIN</option>
                <option value="ADM">ADM</option>
                <option value="QM">QM</option>
                <option value="Audit">Audit</option>
                <option value="PMC">PMC</option>
                <option value="SCM">SCM</option>
                <option value="MOE">MOE</option>
                <option value="PM">PM</option>
              </select>

              <div class="valid-feedback" />
              <div class="invalid-feedback">
                {$_("JOB_FUNCTION_VALIDATION")}
              </div>
            </div>

            <div class="form-floating mb-3">
              <label for="nameInput">{$_("ID_PASSPORT_NUMBER")}</label><input
                type="text"
                bind:value={idNumber}
                class="form-control"
                id="nameInput"
                placeholder="A234567890"
                class:is-valid={submitTry && isValidIdNumber}
                class:is-invalid={submitTry && !isValidIdNumber}
              />
              <div class="valid-feedback" />
              <div class="invalid-feedback">
                {$_("ID_PASSPORT_NUMBER_VALIDATION")}
              </div>
            </div>

            <div class="mb-3">
              <div class="policy-check">
                <input
                  type="checkbox"
                  id="photoPolicyCheck"
                  class="policy-checkbox"
                  bind:checked={photoPolicyChecked}
                  class:is-invalid={submitTry && !isValidPortraitPolicyChecked}
                />
                <button
                  type="button"
                  class="link-button policy-link"
                  on:click|preventDefault={() => {
                    $portraitPolicyOpen = true;
                  }}>{$_("LITEON_PHOTO_POLICY")}</button
                >
              </div>
              {#if submitTry && !isValidPortraitPolicyChecked}
                <div class="text-danger small mt-1">{$_("LITEON_PHOTO_POLICY_VALIDATION")}</div>
              {/if}
            </div>

            {#if loadingState === "NEW"}
              <button
                type="submit"
                class="w-100 btn btn-lg btn-primary mt-4"
                tabindex="0"
                on:click={startAssessment}>{$_("START_ASSESSMENT")}</button
              >
            {:else}
              <div class="spinner-border align-center" role="status">
                <span class="sr-only">{$_("LOADING")}</span>
              </div>
            {/if}

            <hr class="my-4" />
            {$_("TERMS_PART1")}<button
              type="button"
              class="link-button footer-link"
              on:click|preventDefault={() => ($termsAndConditionOpen = true)}
              >{$_("TERMS_PART2")}</button
            >
            {$_("TERMS_PART3")}
            <button
              type="button"
              class="link-button footer-link"
              on:click|preventDefault={() => ($privacyPolicyOpen = true)}
              >{$_("TERMS_PART4")}</button
            >
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  .yellow-banner {
    color: #1e1e1e;
    font-weight: 700;
    text-transform: uppercase;
    background-color: #ffcc07;
    padding: 0.3em;
    font-family: "Noto Sans", serif;
  }

  h3 {
    font-family: "Noto Sans", serif;
    font-weight: 800;
    font-size: xxx-large;
  }

  h4 {
    text-align: left;
    font-family: "Noto Sans", serif;
    font-weight: 500;
  }

  /* Specific styling for Equipment Check and Assessment Protocol h4 elements */
  h4.section-title {
    font-size: 1.15rem;
  }

  label {
    text-align: left;
    text-transform: uppercase;
    font-size: 0.85rem;
  }

  p {
    font-family: "Noto Sans", serif;
  }

  .policy-check {
    display: flex;
    align-items: center;
    gap: 0;
  }

  .policy-checkbox {
    flex-shrink: 0;
    width: 1.5em;
    height: 1.5em;
    margin: 0 12px 0 0;
    cursor: pointer;
    border: 2px solid #adb5bd;
    border-radius: 4px;
  }

  .policy-checkbox.is-invalid {
    border-color: #dc3545;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.2);
  }

  .link-button {
    appearance: none;
    background: transparent;
    border: 0;
    padding: 0;
    font: inherit;
    line-height: inherit;
    color: #00a896;
    text-decoration: none;
    cursor: pointer;
  }

  .link-button:hover,
  .link-button:focus {
    color: #007a6e;
    text-decoration: none;
  }

  .policy-link {
    text-transform: none;
    font-size: 1rem;
    text-align: left;
  }

  .footer-link {
    display: inline;
    vertical-align: baseline;
  }

  .footer-link,
  .footer-link:hover,
  .footer-link:focus {
    color: #00a094ff;
    text-decoration: none;
  }

  .webcam-test-link :global(a) {
    color: #00a896;
    text-decoration: none;
  }

  .webcam-test-link :global(a:hover),
  .webcam-test-link :global(a:focus) {
    color: #007a6e;
    text-decoration: none;
  }
</style>
